var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    class: _vm.mbSmall ? 'mb-4px mb-md-8px' : 'mb-16px mb-md-24px'
  }, [this.$slots['default'] ? _c('div', {
    staticClass: "tit tit--sm"
  }, [_vm._t("default")], 2) : _vm._e()]), this.$slots['text'] ? _c('p', {
    staticClass: "txt txt--xl txt--dark"
  }, [_vm._t("text")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }